module.exports = __webpack_public_path__ + "static/media/logo.598a61ea.svg";